export class Tag {
  constructor(
    public id: number | null,
    public value: string,
    public color: string
  ) {}

  public static get EMPTY(): Tag {
    return new Tag(null, "", "");
  }

  hasValidValue(): boolean {
    return !!this.value && this.value.trim().length > 0;
  }
}
